import React from "react";
import { useTranslation } from "react-i18next";
import { Zap, FileCheck2, Users, EyeOff, Leaf, Wand2 } from "lucide-react";

const ICONS = {
  speed: Zap,
  quote: FileCheck2,
  team: Users,
  discretion: EyeOff,
  products: Leaf,
  tailor: Wand2,
};

const WhyChoose = () => {
  const { t } = useTranslation();
  const keys = ["speed", "quote", "team", "discretion", "products", "tailor"];

  return (
    <section className="section bg-white" data-testid="why-choose-section">
      <div className="container-x">
        <div className="max-w-3xl mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">{t("nav.about")}</p>
          <h2 className="mt-2 font-heading font-extrabold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-slate-900">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {keys.map((k) => {
            const Icon = ICONS[k];
            return (
              <div
                key={k}
                className="rounded-2xl p-6 bg-slate-50 border border-slate-200 hover:border-brand-green/40 transition"
                data-testid={`why-${k}`}
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-white border border-slate-200">
                  <Icon className="h-5 w-5 text-brand-green" />
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-slate-900">{t(`why.items.${k}.title`)}</h3>
                <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{t(`why.items.${k}.desc`)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
